import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import GridInfoText from '../GridInfoText';

const useStyles = makeStyles(theme => ({
  items: {
    paddingTop: theme.spacing(2),
  },
  wrapper: {
    paddingTop: theme.spacing(2.5),
  },
}));

export default function ProfileGrid({ profile }) {
  const classes = useStyles();
  return (
    <Grid className={classes.wrapper} maxwidth="lg">
      <Grid item xs={12} container className={classes.items} spacing={0} wrap="nowrap">
        <GridInfoText name="ID" value={profile.user_id} />
      </Grid>
      <Grid item xs={12} container className={classes.items} spacing={0} wrap="nowrap">
        <GridInfoText name="Name" value={profile.name} />
        <GridInfoText name="Email" value={`${profile.email}`} />
      </Grid>
      <Grid item xs={12} container className={classes.items} spacing={0} wrap="nowrap">
        <GridInfoText name="Picture" value={profile.picture} />
      </Grid>
    </Grid>
  );
}

ProfileGrid.propTypes = {
  profile: PropTypes.shape({
    user_id: PropTypes.string,
    email: PropTypes.string,
    name: PropTypes.string,
    picture: PropTypes.string,
  }).isRequired,
};
